/*
 * Search barcode/EAN fallback
 * ---------------------------
 * The Liquid /search page does NOT match variant barcodes natively (verified:
 * a valid EAN returns 0 products), even though the barcode field is indexed and
 * IS matchable via the Predictive Search API when variants.barcode is in fields.
 *
 * This script bridges that gap ONLY on the /search results page:
 *   1. Read the `q` query param. Bail unless it looks like a barcode (8-14 digits:
 *      EAN-8 / UPC-A / EAN-13 / GTIN-14).
 *   2. If the results grid already has product cards, do nothing (native matched,
 *      or a future Shopify change matches barcodes) — zero layout shift.
 *   3. Otherwise query /search/suggest.json restricted to variants.barcode, then
 *      verify each candidate by fetching its product .js and matching a variant
 *      barcode EXACTLY (search only partial-matches). This defeats false positives.
 *   4. One verified match  -> redirect to that product.
 *      Multiple matches    -> redirect to the first (an EAN maps to one item).
 *      No match            -> leave the empty "no results" state untouched.
 *
 * Root-relative fetches inherit the active market/locale (Shopify.routes.root).
 * Mirrors the lookup+verify strategy of assets/outlet-product-notice.js.
 */
(function () {
  'use strict';

  var BARCODE_RE = /^\d{8,14}$/;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, ''); // '' or '/da'
  }

  function stripQuery(url) {
    return (url || '').split('?')[0];
  }

  function handleFromProduct(p) {
    return p.handle || stripQuery(p.url || '').split('/').pop();
  }

  async function findByBarcode(ean) {
    var params = new URLSearchParams();
    params.set('q', ean);
    params.set('resources[type]', 'product');
    params.set('resources[limit]', '10');
    params.set('resources[options][unavailable_products]', 'last');
    params.set('resources[options][fields]', 'variants.barcode');

    var res = await fetch(root() + '/search/suggest.json?' + params.toString(), {
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) return [];

    var data = await res.json();
    var products =
      (data.resources && data.resources.results && data.resources.results.products) || [];

    // suggest.json matches partially — verify each candidate's exact barcode.
    var matches = [];
    for (var i = 0; i < Math.min(products.length, 5); i++) {
      var verified = await verify(products[i], ean);
      if (verified) matches.push(verified);
    }
    return matches;
  }

  async function verify(suggestProduct, ean) {
    var handle = handleFromProduct(suggestProduct);
    if (!handle) return null;

    var res = await fetch(root() + '/products/' + handle + '.js', {
      headers: { Accept: 'application/json' }
    });
    if (!res.ok) return null;

    var full = await res.json();
    var variant = (full.variants || []).find(function (v) {
      return (v.barcode || '').trim() === ean;
    });
    if (!variant) return null;

    // Prefer the exact variant URL so the matched variant is preselected.
    var url = root() + (full.url || '/products/' + handle);
    if (variant.id) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variant.id;
    return { handle: handle, url: url };
  }

  async function run() {
    var q = new URLSearchParams(window.location.search).get('q');
    if (!q) return;
    q = q.trim();
    if (!BARCODE_RE.test(q)) return;

    // Native already returned products? Leave it alone (no CLS).
    var grid = document.getElementById('filter-results') ||
      document.querySelector('.main-products-grid__results');
    if (grid && grid.querySelector('a[href*="/products/"]')) return;

    try {
      var matches = await findByBarcode(q);
      if (matches.length) {
        window.location.replace(matches[0].url);
      }
    } catch (e) {
      /* network/parse errors are non-fatal — leave the page as-is */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
